/*
 * @Author: your name
 * @Date: 2022-02-08 16:19:42
 * @LastEditTime: 2022-03-09 11:42:21
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /admin/src/utils/index.ts
 */
// Parse the time to string
export const parseTime = (
    time?: object | string | number | null,
    cFormat?: string
): string | null => {
    if (time === undefined || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date: Date
    if (typeof time === 'object') {
        date = time as Date
    } else {
        if (typeof time === 'string') {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(/-/gm, '/')
            }
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj: { [key: string]: number } = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return timeStr
}

const pad2 = (value: number) => value.toString().padStart(2, '0')

/**
 * 解析后端 LocalDateTime（如 2026-08-26T16:40:20 / 2026-08-26 16:40:20），按本地日历时间处理，避免时区偏移。
 */
export const parseLocalDateTime = (
    time?: Date | string | number | null
): Date | null => {
    if (time === undefined || time === null || time === '') {
        return null
    }
    if (time instanceof Date) {
        return Number.isNaN(time.getTime()) ? null : time
    }
    if (typeof time === 'number') {
        const ms = time.toString().length === 10 ? time * 1000 : time
        const date = new Date(ms)
        return Number.isNaN(date.getTime()) ? null : date
    }

    const raw = String(time).trim()
    if (!raw) {
        return null
    }

    const normalized = raw
        .replace(/T/, ' ')
        .replace(/Z$/, '')
        .replace(/[+-]\d{2}:\d{2}$/, '')
        .replace(/\.\d+$/, '')

    const match = normalized.match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ ](\d{2}):(\d{2})(?::(\d{2}))?)?$/
    )
    if (match) {
        const date = new Date(
            Number(match[1]),
            Number(match[2]) - 1,
            Number(match[3]),
            Number(match[4] || 0),
            Number(match[5] || 0),
            Number(match[6] || 0)
        )
        return Number.isNaN(date.getTime()) ? null : date
    }

    const fallback = new Date(raw.includes('-') ? raw.replace(/-/g, '/') : raw)
    return Number.isNaN(fallback.getTime()) ? null : fallback
}

const isSameCalendarDay = (left: Date, right: Date) =>
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate()

/**
 * 表格日期时间展示：当天只显示时间（HH:mm:ss），非当天只显示日期（YYYY-MM-DD）。
 * 适用于后端 LocalDateTime。
 */
export const formatDateOrTime = (
    time?: Date | string | number | null,
    now: Date = new Date()
): string => {
    const date = parseLocalDateTime(time)
    if (!date) {
        return ''
    }
    if (isSameCalendarDay(date, now)) {
        return `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`
    }
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

// Format and filter json data using filterKeys array
export const formatJson = (filterKeys: any, jsonData: any) =>
    jsonData.map((data: any) => filterKeys.map((key: string) => {
        if (key === 'timestamp') {
            return parseTime(data[key])
        } else {
            return data[key]
        }
    }))

// Check if an element has a class
export const hasClass = (ele: HTMLElement, className: string) => {
    return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

// Add class to element
export const addClass = (ele: HTMLElement, className: string) => {
    if (!hasClass(ele, className)) ele.className += ' ' + className
}

// Remove class from element
export const removeClass = (ele: HTMLElement, className: string) => {
    if (hasClass(ele, className)) {
        const reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

// Toggle class for the selected element
export const toggleClass = (ele: HTMLElement, className: string) => {
    if (!ele || !className) {
        return
    }
    let classString = ele.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    ele.className = classString
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr: any) {
    return Array.from(new Set(arr))
}

//throttle.js
/**
 * @param {*} fn 要执行的函数
 * @param {*} interval 时间间隔
 * @returns 
 */
export function throttle(fn, interval) {
    // 1.记录上一次的开始时间
    let lastTime = 0
   
    // 2.事件触发时, 真正执行的函数
    const _throttle = function () {
   
      // 2.1.获取当前事件触发时的时间
      const nowTime = new Date().getTime()
   
      // 2.2.使用当前触发的时间和之前的时间间隔以及上一次开始的时间, 计算出还剩余多长时间需要去触发函数
      const remainTime = interval - (nowTime - lastTime)
      //第一次会执行，原因是nowTime刚开始是一个很大的数字，结果为负数
      //若最后一次没能满足条件，不会执行
      if (remainTime <= 0) {
        // 2.3.真正触发函数
        fn()
        // 2.4.保留上次触发的时间
        lastTime = nowTime
      }
    }
   
    return _throttle
  }
